import { NJText } from '@engie-group/fluid-design-system-react';
import { UMIcon, UMR } from '../../urbanmap/_components';
import { plansUsing } from './model';
import { FAMILIES, type AnySet, type Family, type Project } from './types';
import { ACCENT, ChainBanner } from './ui';

interface Props {
  project: Project;
  onEnterFamily: (f: Family) => void;
}

/**
 * Écran d'accueil des hypothèses : 6 grandes tuiles (une par famille).
 * Pas de carte ici : l'utilisateur lit ses hypothèses au calme. Cliquer une tuile entre dans la famille.
 */
export function FamilyTiles({ project, onEnterFamily }: Props) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16, padding: 24, overflowY: 'auto', maxWidth: 1000, margin: '0 auto', width: '100%' }}>
      <div>
        <NJText as="h2" scale="lg" style={{ margin: 0 }}>Hypothèses du projet</NJText>
        <NJText scale="sm" style={{ margin: '2px 0 8px', color: UMR.textSecondary }}>
          Chaque famille contient des jeux nommés et indépendants. Un plan de dev (à venir) combinera un jeu par famille. Choisissez une famille pour voir ses jeux.
        </NJText>
        <ChainBanner step="hypotheses" />
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 16 }}>
        {FAMILIES.map((f) => {
          const sets = project.sets[f.key] as AnySet[];
          const used = sets.filter((s) => plansUsing(project, f.key, s.id).length).length;
          return (
            <button
              key={f.key}
              type="button"
              onClick={() => onEnterFamily(f.key)}
              aria-label={`Famille ${f.title} — ${sets.length} jeux`}
              style={{
                cursor: 'pointer', fontFamily: UMR.font, textAlign: 'left', background: UMR.white,
                border: `1px solid ${UMR.border}`, borderTop: `3px solid ${ACCENT}`, borderRadius: 4,
                padding: 18, display: 'flex', flexDirection: 'column', gap: 10, minHeight: 150,
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                <span style={{ width: 44, height: 44, borderRadius: 8, background: 'var(--nj-core-color-teal-100, #e3f4f2)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <UMIcon name={f.icon} size={26} color={ACCENT} />
                </span>
                <span style={{ fontSize: 18, fontWeight: 700 }}>{f.title}</span>
                {f.map !== 'none' && (
                  <span title="Réglages sur la carte" style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: 4, fontSize: 11, color: UMR.textSecondary }}>
                    <UMIcon name="map" size={14} color={UMR.textSecondary} /> carte
                  </span>
                )}
              </div>
              <span style={{ fontSize: 13, color: UMR.textSecondary, flex: 1 }}>{f.tagline}</span>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
                <span style={{ fontSize: 13, fontWeight: 700 }}>{sets.length} jeu{sets.length > 1 ? 'x' : ''}</span>
                <span style={{ fontSize: 12, color: used ? ACCENT : UMR.textSecondary }}>
                  {used ? `${used} utilisé${used > 1 ? 's' : ''} par des plans` : 'aucun utilisé par un plan'}
                </span>
                <span style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: 2, fontSize: 12, color: ACCENT, fontWeight: 600 }}>
                  Ouvrir <UMIcon name="chevron_right" size={16} color={ACCENT} />
                </span>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
